import { render } from "./ZinsSettings.vue?vue&type=template&id=b0577b34"
import script from "./ZinsSettings.vue?vue&type=script&lang=js"
export * from "./ZinsSettings.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__